var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "loading_svg__lds-rolling",
  preserveAspectRatio: "xMidYMid",
  style: {
    background: "0 0"
  },
  viewBox: "0 0 100 100"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 35,
  fill: "none",
  stroke: "inherit",
  strokeDasharray: "164.93361431346415 56.97787143782138",
  strokeWidth: 6,
  transform: "rotate(109.866 50 50)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "0s",
  calcMode: "linear",
  dur: "1.2s",
  keyTimes: "0;1",
  repeatCount: "indefinite",
  type: "rotate",
  values: "0 50 50;360 50 50"
}))));
export { SvgLoading as ReactComponent };
export default __webpack_public_path__ + "static/media/loading.c0c6af2e.svg";